
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page.tsx";
import Register from "../pages/register/page.tsx";
import Plans from "../pages/plans/page.tsx";
import Dashboard from "../pages/dashboard/page.tsx";
import { PresupuestosPage } from "../pages/presupuestos/page";
import { RequireAuth } from "../modules/auth/ui/RequireAuth";
import OpenAITest from "../components/OpenAITest";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/plans",
    element: <Plans />,
  },
  {
    path: "/dashboard",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "ingresos",
        element: <Dashboard />,
      },
      {
        path: "egresos", 
        element: <Dashboard />,
      },
      {
        path: "inversiones",
        element: <Dashboard />,
      },
      {
        path: "patrimonio",
        element: <Dashboard />,
      },
      {
        path: "presupuestos",
        element: <Dashboard />,
      },
    ],
  },
  {
    path: "/presupuestos",
    element: (
      <RequireAuth>
        <PresupuestosPage />
      </RequireAuth>
    ),
  },
  {
    path: "/test-openai",
    element: <OpenAITest />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
